import React from "react";
import NavBar from "../../components/common/NavBar";
import GuestsList from "../../components/GuestsList";
import BookingDetailsSection from "../../components/BookingDetailsSection";

import {SummaryContainer, GuestPanel, BookingPanel, VerticalLine, VerticalLineContainer} from "./styled"

function SummaryView() {
  return (
    <>
      <NavBar title="Confirm Booking Details" />
      <SummaryContainer>
        <GuestPanel>
          <GuestsList />
        </GuestPanel>
        <VerticalLineContainer>
          <VerticalLine />
        </VerticalLineContainer>
        <BookingPanel>
          <BookingDetailsSection />
        </BookingPanel>
      </SummaryContainer>

      
    </>
  );
}

export { SummaryView };
